<template>
  <section-container>
    <header-page title_header="Assinatura" sub_header="Escolha seu plano" />
    <div
      class="my-5 bg-indigo-100 text-gray-800 font-bold px-4 py-3 rounded border border-indigo-500"
    >
      Aproveite a promoção com 50% de desconto para os 100 primeiros assinantes✨
    </div>
    <content-e>
      <div class="bg-white shadow-2l w-full flex flex-wrap rounded-lg p-6">
        <div
          class="p-4 xl:w-1/3 md:w-1/2 w-full"
          v-for="plan in plans"
          :key="plan.id"
        >
          <Plan
            :price="parseFloat(plan.total)"
            :discount="parseFloat(plan.discount)"
            :recorrence="1"
            :plan_id="plan.stripe_plan"
            :title="plan.title"
            :popular="my_plan === plan.stripe_plan ? true : false"
          ></Plan>
        </div>
      </div>
    </content-e>
  </section-container>
</template>

<script>
/* eslint-disable no-useless-escape */
import Plan from '@/components/Subscription/Plan'

export default {
  name: 'subscription',
  data() {
    return {
      plans: '',
      my_plan: 1
    }
  },
  components: {
    Plan
  },
  methods: {
    getTokenCard() {}
  },
  async beforeMount() {
    this.$store.dispatch('SUBSCRIPTION_PLANS').then(response => {
      this.plans = response.data.plans
      this.my_plan = response.data.my_plan
    })
  },
  destroyed() {}
}
</script>

<style></style>
